/* @flow */

export default class EligibilityQuestionnaire {
  mustAnswerBusinessOpportunityQuestions: boolean;
  mustAnswerEligibilityQuestions: boolean;
}
